import axios from 'axios';
import type { DateTime } from 'luxon';

export default class InternalLinksService
{
    public static async getList(filter: FilterModel, pager: Pager)
    {
        return (await axios.get<Pagination<Resource<ListItemModel>>>(`admin/cms/internal-links`, {
            params: { ...filter, ...pager.data() }
        })).data;
    }

    public static async getOccurrence(websiteId: number, locale: string, text: string)
    {
        return (await axios.post(`admin/cms/internal-links/${websiteId}/${locale}/occurrence`, text.toString(), {
            headers: { 'Content-Type': 'application/json' }
        })).data;
    }

    public static async fetch(id: number)
    {
        return (await axios.get<Resource<FormModel>>(`admin/cms/internal-links/${id}`)).data;
    }

    public static async create(model: FormModel)
    {
        return (await axios.post(`admin/cms/internal-links`, model)).data as Resource<FormModel>;
    }

    public static async update(id: number, model: FormModel)
    {
        return (await axios.put(`admin/cms/internal-links/${id}`, model)).data as Resource<FormModel>;
    }

    public static async remove(id: number)
    {
        return (await axios.delete(`admin/cms/internal-links/${id}`)).data as Statement;
    }
}

export interface ListItemModel
{
    id: number;
    phrase: string;
    url: string;
    count: number;
    dateCreatedUtc: DateTime;
    DateModifiedUtc?: DateTime;
    websiteId: number;
    locale: string;
}

export interface FormModel
{
    id: number;
    phrase: string;
    url: string;
    target: string;
    nofollow: boolean;
    websiteId: number;
    locale: string;
    isUsed: boolean;
}

export interface FilterModel
{
    websiteId: number;
    locale: string;
    phrase: string;
    url: string;
}
